module.exports = __webpack_public_path__ + "media/ppc/cbs-money-watch-86c93f29.png";